<div class="callback-page">
  <div class="loading-container">
    <div class="spinner"></div>
    <p class="loading-text">Идет обработка данных, пожалуйста подождите...</p>
  </div>
</div>
